import { c as _c } from "react/compiler-runtime";
import type { LiveRoomRankMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import masking from '@module/utils/masking';
interface Props {
  item: LiveRoomRankMessage;
}
export default function LiveRoomRankChat(props) {
  const $ = _c(8);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full bg-cht_har_ranking text-center leading-[28px]">{"\uD558\uD2B8 \uC120\uBB3C \uB7AD\uD0B9"}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== message.opt) {
    t1 = message.opt.map(_temp);
    $[1] = message.opt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="whitespace-pre-wrap rounded-[10px] border-2 border-cht_har_ranking">{t0}<ul className="py-[5px] pr-[10px] pl-[5px] text-[13px] text-cht_baseFg">{t1}</ul></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-cht_baseFg">{"\uD558\uD2B8 \uC120\uBB3C \uB7AD\uD0B9\uC740 1\uBD84\uB9C8\uB2E4 \uAC31\uC2E0\uB429\uB2C8\uB2E4."}</div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="mb-4">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(userItem, index) {
  return <li key={userItem.userIdx} className="my-3 flex justify-between"><div className="flex"><div className="w-[20px] text-center">{index + 1}</div><div className="mr-2">{userItem.userNick} ({masking(userItem.userId)})</div></div><div>{`${userItem.totalCoin.toLocaleString()} 개`}</div></li>;
}